import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { CandleData } from 'client/voladeum/candles/types';

export interface VisibleTimeseries {
  start: number;
  end: number;
}

export interface VisibleTimeseriesResponse {
  visible: VisibleTimeseries;
  setVisible: Dispatch<SetStateAction<VisibleTimeseries>>;
}

export const useVisibleTimeseries = (
  candles: CandleData[],
  candle_window: number
): VisibleTimeseriesResponse => {
  const [visible, setVisible] = useState<VisibleTimeseries>({ start: 0, end: 1 });

  useEffect(() => {
    if (candles.length === 0) return;

    const lastIndex = candles.length - 1;
    const sliceCount = Math.min(candles.length, candle_window);
    const startIndex = Math.max(0, lastIndex - sliceCount);

    const start = candles[startIndex].x ?? 0;
    const end = candles[lastIndex].x ?? 1;

    setVisible({ start, end });
  }, [candle_window, candles]);

  return { visible, setVisible };
};
